import { useSelector } from "react-redux";

export default function useAuth() {
  const auth = useSelector((state) => state.auth);

  if (auth?.accessToken && auth?.user) {
    if (auth.user.role === "admin") {
      return "admin";
    } else if (auth.user.role === "student") {
      return "student";
    }
  } else {
    return false;
  }
}
